export default __webpack_public_path__ + "static/media/guarderia2.236fd83a.jpg";